<template>
  <Modal
    v-if="doShow"
    class="LaptopImportModal"
    @close="$emit('update:doShow', false)">
    <Loader v-if="isImporting" />
    <FileDrop
      v-else
      accept=".tsv,.txt"
      :message="$t('dropFile')"
      type="LAPTOP_SHEET_IMPORT"
      @success="importLaptopsSheet" />
  </Modal>
</template>

<script>
import FileDrop from '@components/fields/FileDrop'
import { actions } from '@utils'

export default {
  components: { FileDrop },
  props: {
    doShow: Boolean,
    isImporting: Boolean,
  },
  methods: {
    async importLaptopsSheet(event) {
      await this.$wrap(
        this.CREATE_LAPTOP_IMPORT_EXPORT({
          fileId: event.file.id,
        }), 'isImporting')
    },
    ...actions('CREATE_LAPTOP_IMPORT_EXPORT'),
  },
}
</script>

<style lang="scss">
.LaptopImportModal {
}
</style>

<i18n>
{
  "en": {
    "dropFile": "Drop sheet to update fields"
  }
}
</i18n>
